import React, { useState, useEffect } from "react";
import styles from "./search.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import HeaderMain from "../dasboard-component/Components/HeaderMain";

const Search = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const decodeBuffer = (imageData) => {
    if (!imageData) return null;
    const base64Prefix = "data:image/jpeg;base64,";
    if (imageData.startsWith(base64Prefix)) {
      try {
        const base64String = imageData.slice(base64Prefix.length);
        const decoded = atob(base64String);
        console.log("Decoded image path:", decoded);
        return decoded === "null" ? null : decoded;
      } catch (error) {
        console.error("Error decoding base64 image:", error);
        return null;
      }
    }
    return imageData; // Fallback if not a base64 data URL
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      fetchSuggestions(searchTerm);
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  const fetchSuggestions = async (term) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/article/suggest-articles?term=${term}`
      );
      if (response.ok) {
        const data = await response.json();
        console.log("API response:", data);
        const processedSuggestions = data
          .map((article) => ({
            id: article.id,
            title: article.title || "Untitled",
            image: decodeBuffer(article.image),
          }))
          .filter((article) => article.id && article.title);
        console.log("Processed suggestions:", processedSuggestions);
        setSuggestions(processedSuggestions);
      } else {
        console.error("Failed to fetch suggestions:", response.status);
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setSuggestions([]);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    const normalizedPath = imagePath.replace(/\\/g, "/");
    const url = `${process.env.REACT_APP_BASE_URL}/Uploads/${normalizedPath
      .split("/")
      .pop()}`;
    console.log("Image URL:", url);
    return url;
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSuggestionClick = (article) => {
    navigate(`/article/${article.id}`);
  };

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/search-results?q=${encodeURIComponent(searchTerm)}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleLoginClick = () => {
    navigate("/loginContributor");
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  return (
    <div className={`${styles.app}`}>
      <HeaderMain pageType="search-article" />

      <div className={styles.contentWrapper}>
        <main className={styles.main}>
          <div className={styles.mainLogo}>
            <img src="/logo.png" alt="Logo" />
          </div>
          <div className={`${styles.searchContainer} ${styles.mainSearch}`}>
            <input
              type="text"
              placeholder="Search Articles"
              className={styles.mainSearchBar}
              value={searchTerm}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
            {suggestions.length > 0 ? (
              <ul className={styles.suggestions}>
                {suggestions.map((article, index) => (
                  <li
                    key={article.id || index}
                    onClick={() => handleSuggestionClick(article)}
                  >
                    {article.image && (
                      <img
                        src={getImageUrl(article.image)}
                        alt={`${article.title} thumbnail`}
                        loading="lazy"
                        onError={() =>
                          console.error(
                            `Failed to load image for ${
                              article.title
                            }: ${getImageUrl(article.image)}`
                          )
                        }
                      />
                    )}
                    <span className={styles.suggestionTitle}>
                      {article.title}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p></p>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Search;
